import * as React from 'react';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { PAGE_BREAK_CLASSNAME, PAGE_CLASSNAME } from '@doltech/core/lib/pdf/constant';

interface PdfPageProps {
  children: ReactNode;
}

const PageWrapper = styled.div``;
const PageBreaker = styled.div<{ height: number }>`
  height: ${(p) => p.height}px;
`;
export const PdfPage = ({ children }: PdfPageProps) => {
  return (
    <PageWrapper className={PAGE_CLASSNAME}>
      {children}
      <PageBreaker height={1} className={PAGE_BREAK_CLASSNAME} />
    </PageWrapper>
  );
};
